import styled from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import { mainColor } from "../../../styles/style-guide";
import { ImageBoxUtils } from "../../utils/styles/Utils";

export const Section = styled.section`
  ${tw`py-20 px-0`};
`;

export const Image = styled.div`
  ${tw` w-2/5 px-4 py-0`};

  ${ImageBoxUtils} {
    ${tw`bg-white25 max-w-sm border border-solid border-white40 m-auto rounded-xl`};
  }

  ${media.tablet} {
    ${tw`w-full`}
  }
`;

export const Photo = styled.img`
  ${tw``};
`;

export const Content = styled.div`
  ${tw`w-3/5 px-4 py-0`};

  ${media.tablet} {
    ${tw`w-full mt-8 px-10`}
  }

  ${media.phone} {
    ${tw`w-full mt-8 px-7`}
  }
`;

export const Desc = styled.p`
  ${tw`text-justify`};
`;

export const SubHeader = styled.h3`
  ${tw`capitalize text-xl my-5 mx-0`};
`;

export const Skills = styled.div`
  ${tw`flex flex-wrap`};
`;

export const SkillItem = styled.div<{ main?: boolean }>`
  ${tw`bg-white25 border border-solid border-white40 py-1.5 px-4 capitalize m-0 mr-2.5 mb-2.5 rounded-full`};

  ${({ main }) => main && `border-color: ${mainColor}`}
`;
